import { mockResponse, request, isMockMode } from './client.js';

// 使用者管理 API。與角色共用 isMockMode('roles') 這個開關（同一功能一起切真/假）。
// 後端做好後在 .env 設 REACT_APP_USE_MOCK_ROLES=false 即接真實後端。
//
// User 形狀：{ id, username, email, role(角色代號), enabled, level(會員等級數字) }

let _users = [
  { id: 'u-001', username: '王家瑋', email: 'player@michidart.tw', role: 'customer', enabled: true, level: 0, referralCode: 'A2B3C4', referredByName: null },
  { id: 'u-002', username: '小編阿哲', email: 'editor@michidart.tw', role: 'theme_editor', enabled: true, level: 1, referralCode: 'D5E6F7', referredByName: '王家瑋' },
  { id: 'a-001', username: '管理員', email: 'admin@michidart.tw', role: 'master', enabled: true, level: 2, referralCode: 'G8H9JK', referredByName: null },
];

const clone = (u) => ({ ...u });

export function adminGetUsers({ sort, page = 1, limit = 10 } = {}) {
  if (!isMockMode('roles')) {
    const qs = new URLSearchParams();
    if (sort) qs.set('sort', sort);
    qs.set('page', page);
    qs.set('limit', limit);
    return request(`/api/admin/users?${qs.toString()}`);
  }
  return mockResponse(() => {
    const [sf, sd] = (sort || '').split(',');
    let rows = _users.map(clone);
    if (sf) {
      rows.sort((a, b) => {
        const r = String(a[sf] ?? '').localeCompare(String(b[sf] ?? ''), undefined, { numeric: true });
        return sd === 'desc' ? -r : r;
      });
    }
    const start = (page - 1) * limit;
    const items = rows.slice(start, start + limit);
    return { items, total: rows.length, page, limit, totalPages: Math.ceil(rows.length / limit) };
  });
}

export function adminAssignRole(id, role) {
  if (!isMockMode('roles')) return request(`/api/admin/users/${id}/role`, { method: 'PATCH', body: { role } });
  return mockResponse(() => {
    const user = _users.find(u => u.id === id);
    if (user) user.role = role;
    return user ? clone(user) : null;
  });
}

export function adminSetUserLevel(id, level) {
  if (!isMockMode('roles')) return request(`/api/admin/users/${id}/level`, { method: 'PATCH', body: { level } });
  return mockResponse(() => {
    const user = _users.find(u => u.id === id);
    if (user) user.level = level;
    return user ? clone(user) : null;
  });
}
